import http from "./apiServices"

export const postReceiptPdfById = ({ receiptId }) => {
  return http.post(`receipts/${receiptId}/pdf`)
}
